import { environment } from '@environments/environment';
import { Rescatable } from '../Rescatable';

export class FeaturesProduct extends Rescatable {
  static _name = 'FeaturesProduct';
  static pathRequest = `${environment.apiStatic}armado_pc_caracteristicas_plano`;
  static pathRequestIndex = this.pathRequest;
  static pk: keyof FeaturesProduct = 'id_producto';
  id_producto: number;

  constructor(element: FeaturesProduct) {
    super(element);
  }
}
